import { useInfiniteQuery } from '@tanstack/react-query'

import { fetchReservationRefunds } from '@/lib/venue/reservationRefundApi'
import type { ReservationRefundListFilter } from '@/lib/venue/reservationRefundViewModel'

export function reservationRefundsQueryKey(venueId: string, filter: ReservationRefundListFilter) {
  return ['venue', venueId, 'reservation-refunds', 'list', filter] as const
}

export function useVenueReservationRefunds(venueId: string, filter: ReservationRefundListFilter) {
  return useInfiniteQuery({
    queryKey: reservationRefundsQueryKey(venueId, filter),
    queryFn: ({ pageParam }: { pageParam: string | undefined }) =>
      fetchReservationRefunds(venueId, filter, pageParam),
    initialPageParam: undefined as string | undefined,
    getNextPageParam: (lastPage) => (lastPage.nextExist ? (lastPage.nextCursor ?? undefined) : undefined),
  })
}
